import { render } from "./Clienti.vue?vue&type=template&id=78e5d5e8&scoped=true&ts=true"
import script from "./Clienti.vue?vue&type=script&lang=ts"
export * from "./Clienti.vue?vue&type=script&lang=ts"

import "./Clienti.vue?vue&type=style&index=0&id=78e5d5e8&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_plan_1778832654194047890/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e5d5e8"]])

export default __exports__